import React, { useRef } from "react";
import styles from "./Home.module.sass";

import HeroBanner from "./HeroBanner";
import Confidentialite from "./Confidentialite";
import AppelAction from "../../components/AppelAction";

const Confidentialites = () => {

  return (
    <>
      <HeroBanner />
      <Confidentialite />
      <AppelAction className="section-border-top" />
    </>
  );
};

export default Confidentialites;
